"use client";

import { useForm } from "react-hook-form";
import api from "../api";
import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Tooltip } from "flowbite-react";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import TextArea from "./TextArea";

export default function ReviseAnswerModal({ defaultValues, open, onClose }) {
  const [loading, setLoading] = useState(false);

  const { register, getValues, setValue, reset } = useForm({
    defaultValues: {
      chatbot_uuid: localStorage.getItem("chatbot_uuid"),
      question: "",
      agent_response: "",
      expected_response: "",
    },
  });

  const submit = async e => {
    try {
      e.preventDefault();
      e.stopPropagation();

      setLoading(true);

      const input = getValues();

      await api.post("/api/save-revised-answer", input);

      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const search = async () => {
    try {
      const values = getValues();

      const { data } = await api.get("/api/search-revised-answer", {
        params: {
          chatbot_uuid: values.chatbot_uuid,
          question: values.question,
          agent_response: values.agent_response,
        },
      });

      if (data) {
        if (data.question) {
          setValue("question", data.question);
        }
        if (data.question) {
          setValue("agent_response", data.agent_response);
        }
        if (data.question) {
          setValue("expected_response", data.expected_response);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (open) {
      reset();

      if (defaultValues.agent_response) {
        setValue("agent_response", defaultValues.agent_response);
      }

      if (defaultValues.question) {
        setValue("question", defaultValues.question);
      }

      search();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues, open]);

  return (
    <Modal
      title={
        <div className="flex gap-1 items-center">
          <span>Revise Answer</span>{" "}
          {open && (
            <Tooltip
              theme={{
                target: "flex",
              }}
              content={
                <div className="max-w-sm">
                  <span>
                    This will be used to train your AI Agent in the best way to
                    respond to certain questions. Your AI will take this and
                    will put it’s own twist based on your AI agent instructions
                    to make it more conversational. You do not need to perfect
                    the tone here.
                  </span>
                </div>
              }
            >
              <QuestionMarkCircleIcon className="size-5 cursor-pointer" />
            </Tooltip>
          )}
        </div>
      }
      open={open}
      onClose={onClose}
      isSubmitting={loading}
      onSubmit={submit}
    >
      <div className="flex flex-col gap-4">
        <div>
          <label
            htmlFor="question"
            className="block text-sm/6 font-medium text-gray-900"
          >
            Question
          </label>
          <div className="mt-2">
            <TextArea rows={4} name="question" register={register} />
          </div>
        </div>

        <div>
          <label
            htmlFor="agent_response"
            className="block text-sm/6 font-medium text-gray-900"
          >
            Agent Response
          </label>
          <div className="mt-2">
            <TextArea rows={12} name="agent_response" register={register} />
          </div>
        </div>

        <div>
          <label
            htmlFor="expected_response"
            className="block text-sm/6 font-medium text-gray-900"
          >
            Expected Response
          </label>
          <div className="mt-2">
            <TextArea rows={4} name="expected_response" register={register} />
          </div>
        </div>
      </div>
    </Modal>
  );
}
